/* Component Dependencies */
var reservationLookupTemplate = require( 'templates/reservationLookup.hbs' );
var reservationLookupFindReservationTemplate = require( 'templates/reservationLookup-findReservation.hbs' );
var reservationLookupCheckinTemplate = require( 'templates/reservationLookup-checkin.hbs' );
var reservationLookupRewardsTemplate = require( 'templates/reservationLookup-rewards.hbs' );
var reservationLookupConfirmationTemplate = require( 'templates/reservationLookup-searchByConfirmationNumber.hbs' );
var reservationLookupExistingReservationTemplate = require( 'templates/reservationLookup-existingReservation.hbs' );
var reservationLookupSwiTemplate = require( 'templates/reservationLookup-swi.hbs' );
var AriesComponent = require( 'libs/aries-component' );
var AutoCompleteHandler = require('libs/auto-complete-handler');
var AutoCompleteHandlerV2 = require('libs/auto-complete-handler-v2');
var $ = require( 'jquery' );
var DateHandler = require('libs/date-handler');
var Popup = require('libs/popup');
var ResponsiveUtils = require('utils/responsiveUtils');
var PubSub = require('libs/pub-sub');
var googleApiWrapper = require('js-google-api-wrapper');
var GoogleAutocompleteHandler = require('libs/autocompleteHandler');
var AutocompleteFormFieldMapper = require('libs/autocompleteHandler/autocompleteFormFieldMapper');
var AutocompleteFormMapping = require('libs/autocompleteHandler/autocompleteFormMapping');
var recentSearchService = require('libs/autocomplete/recentSearchService');
var AutoCompleteType = require('utils/autoCompleteTypeHandler');

AriesComponent.create({
  type: 'reservationLookup',
  template: {
    'reservationLookup': reservationLookupTemplate,
    'reservationLookup-findReservation': reservationLookupFindReservationTemplate,
    'reservationLookup-checkin': reservationLookupCheckinTemplate,
    'reservationLookup-rewards' : reservationLookupRewardsTemplate,
    'reservationLookup-searchByConfirmationNumber' : reservationLookupConfirmationTemplate,
    'reservationLookup-existingReservation': reservationLookupExistingReservationTemplate,
				'reservationLookup-swi' : reservationLookupSwiTemplate
  },
  events: {
    'click .js-icon-calendar': 'triggerInput', //open calendar on click of calendar-icon
    'click .m-checkout-date-container .m-icon-trigger': 'triggerInput', //open calendar on click of down-icon
    'click .js-single-calendar-icon': 'triggerSingleCalendar', //Functionality to change calendar drop-down icon
    'click .print-button':'showPrintDialog',
    'click .js-clear-button': 'clearAll',
    'click .js-date-picker': 'removeReadOnly',
    'keyup .js-input-change-handler': 'inputChangeHandler'
  },
  isAssociateView: false,
  bindEvents: function(jquery) {
    var _self = this;
    _self.$ = jquery;
    _self.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
    // set associate view flag
    this.isAssociateView = this.$el.find('input[name="associateViewFlag"]').length > 0;

    this.isExistingReservationTile = _self.$el.find('.js-existing-reservation-tile').length ? true : false;
    this.singleCalendar = _self.$el.find('.js-single-calendar-icon');
    this.inputDateFrom = _self.$el.find('.js-date-from');
    this.autocompleteInputEl = this.$el.find('#search-location')[0];
    this.enableCustomAutoSuggest = this.$el.data('custom-auto-suggest');
    this.initDateHandler();
    if (_self.$el.find('.search-reservation').length){
      var resLookupForm = new Popup({
        items: {
          src: '.modal-content',
          type: 'inline'
        },
        selector: '.search-reservation',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      resLookupForm.register();
      _self.$el.find('.cancel-btn').on('click', function(e){
        e.preventDefault();
        _self.pubsub.publish('POPUP_CLOSE');
      });
      _self.$el.find('.js-single-calendar-icon').on('click', function(e){
        _self.triggerSingleCalendar(e);
      }); 
    }
    if (_self.$el.find('.lookup-search').length){
      var resLookupForm = new Popup({
        items: {
          src: '.modal-content',
          type: 'inline'
        },
        selector: '.lookup-search',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      resLookupForm.register();
      _self.$el.find('.cancel-btn').on('click', function(e){
        e.preventDefault();
        _self.pubsub.publish('POPUP_CLOSE');
      });
      _self.$el.find('.js-single-calendar-icon').on('click', function(e){
        _self.triggerSingleCalendar(e);
        }); 
    }
    this.initResponsiveUtils();
    this.initAutocomplete();

    // execute change method only once to remove placeholder
    _self.$(this.$el.find('.select-brand-dropdown')).on('change', _self.inputChangeHandler.bind(_self));
  },
  initAutoCompleteHandler: function() {
	/*Hotel search auto suggest handler*/
    if (this.$el.find('.js-hotel-name-autocomplete').length) {
      this.autoCompleteHandler = AutoCompleteHandler.create({
        $el: this.$el.find('.js-hotel-name-autocomplete'),
        $parent: this,
        onListItemSelect: _.bind(this.setHotelCode, this)
             	
      });
      this.autoCompleteHandler.init();
    }
  },
  initAutoCompleteTypeHandler: function() {
  /*Hotel search auto suggest handler*/
    if (this.$el.find('.js-city-name-autocomplete').length) {
      this.autoCompleteTypeHandler = AutoCompleteType.create({
        $el: this.$el.find('.js-city-name-autocomplete'),
        $parent: this
      });
      this.autoCompleteTypeHandler.init();
    }
  },
  initAutoCompleteHandlerV2: function() {
  /*Hotel search auto suggest handler*/
    if (this.$el.find('.js-hotel-name-autocomplete').length) {
      this.autoCompleteHandlerV2 = AutoCompleteHandlerV2.create({
        $el: this.$el.find('.js-hotel-name-autocomplete'),
        $parent: this,
        onListItemSelect: _.bind(this.setHotelCode, this)
              
      });
      this.autoCompleteHandlerV2.init();
    }
  },
  setHotelCode: function(autocompleteContext){
    var hotelCodeVal = autocompleteContext.propertyCode;
	  this.$el.find("input[name='propertyCode']").val(hotelCodeVal);
  },

  /**
  * Conditionally initialize autocomplete handler for Marriott or Google Places API (R3 Change)
  */
  initAutocomplete: function () {
    var _self = this;
    var googleMapOptions = _self.$el.data('googleApiOptions') || {};
    var geoLocationCN = _self.$el.find('input[name="geoLocationCN"]').val() || null;

    if(this.enableCustomAutoSuggest){
      this.$el.find(".js-auto-complete-input").addClass('js-auto-complete-input-v2');
      _self.initAutoCompleteHandlerV2();
    }else{
      if (geoLocationCN && geoLocationCN === 'true') {
        $(this.autocompleteInputEl).addClass('js-auto-complete-input');
      }
      else {
        if(googleMapOptions && googleMapOptions.api){
           googleApiWrapper.loadApi(googleMapOptions.api)
          .then(function (apiWrapper) {
            new GoogleAutocompleteHandler(_self, apiWrapper, {
              disableLocationSearch: true,
              listContainerEl: $('.js-city-name'),
              types: _self.isAssociateView? ['(cities)'] : null
            });
          });
        _self.updateRecentSearchData();
        }
      }
      _self.initAutoCompleteHandler();
    }
    _self.initAutoCompleteTypeHandler();
  },

  /**
  * Update recent search data in locastorage if available in search form inputs
  */
  updateRecentSearchData: function () {
    var $form = this.$el.find('form'),
      autocompleteFormFieldMapper = new AutocompleteFormFieldMapper($form[0], AutocompleteFormMapping.get($form.attr('id'))),
      data = autocompleteFormFieldMapper.getFormData(),
      hasEmptyVal = false,
      fields = ['placeId', 'mainText', 'secondaryText', 'stateProvince', 'country'],
      recentSearch = recentSearchService.get('miRecentSearchPlaces', 3);

    fields.forEach(function (item) {
      if (!data[item]) {
        hasEmptyVal = true;
      }
    });

    if (hasEmptyVal === false) {
      recentSearch.set(data, 'placeId');
    }
  },
  initDateHandler: function() {
    var _self = this;
    var dateHandler = new DateHandler({
      $el: this.$el.find('.js-calendar-container'),
      $parent: _self,
      singleDate: true,
      bindSingleDateEvents: _self.isExistingReservationTile,
      bindSingleCalendar: _self.singleCalendar
    });
    dateHandler.init();
  },
  /**
  * This function is used to initiate responsive utils
  */
 initResponsiveUtils: function() {
    this.responsiveUtils = ResponsiveUtils.create({
     
    });
    this.responsiveUtils.init();
  },
  triggerInput:function(event){
    event.stopPropagation();
    var $input = $(event.target).parent().find('.js-date-from');
    setTimeout(function() { $input.focus(); });
    this.showCalendar();
  },
  //New changes to open single calendar
  triggerSingleCalendar: function(event){
    var _self = this;
    event.stopPropagation();
    var $picker = _self.$el.find('.picker');
    if($(_self.singleCalendar).hasClass('arrow-down-close')){
      $(_self.singleCalendar).removeClass('arrow-down-close');
      return false;
    }
    if($(_self.singleCalendar).hasClass('t-icon-arrow-down')){
      $picker.addClass('picker--opened').addClass('picker--focused'); 
      $(_self.singleCalendar).removeClass('t-icon-arrow-down').addClass('t-icon-arrow-up');
      $(_self.inputDateFrom).focus();
      return false;
    }else{
      $picker.removeClass('picker--opened').removeClass('picker--focused');
      $(_self.singleCalendar).removeClass('t-icon-arrow-up').addClass('t-icon-arrow-down');
      return false;
    }
  },
  /**
   * This function opens the browser print dialog
   * @param {Object} Event object is passed
   */
  showPrintDialog: function(event){
    event.preventDefault();
    event.stopPropagation();
    window.print();
  },
  /*This function is used to clear all values 
   * Context used in this method is to indicate backend that this is a clear session call.
   */
  clearAll: function () {
    var _self = this,context={};
    context={
      'clearExistingReservationSession':true
    }
    _self.refresh(context);
  },
  /*
   * callback for after component refresh
   */
  afterComponentRefresh : function _afterComponentRefresh(){
	  this.pubsub.publish('TARGETTED_ERRORMSG_REFRESH');
  },
  removeReadOnly: function _removeReadOnly(){
    var _self = this;
    _self.$el.find('input.existing-date-input').removeAttr('readonly');
    _self.$el.find('input.existing-date-input').focus();
  },
  /**
  * This function is used to focus on calendar input field to show calendar
  * @param {object} event object
  * @returns {boolean} Return false to stop default event action
  */
  showCalendar:function _showCalendar(event){
    var $input = this.$el.find('.js-date-from');
    $input.focus();
    return false;
  },
  /**
  * This function is used to disable the optional fields
  * @param {object} event object
  */
  inputChangeHandler: function _inputChangeHandler(event) {
    var _self = this;
    var fieldsArray = $(event.target).data('fields-to-be-disabled').split(',');
    fieldsArray.forEach(function (element) {
      var $element = _self.$el.find('#' + element);
      if ($(event.target).val() !== '') {
        $element.attr('disabled', 'disabled').removeClass('is-error');
      } else {
        $element.removeAttr('disabled');
      }
    });
    if (_self.$(_self.$el.find('.select-brand-dropdown')).val() ) {
      _self.$el.find('#' + _self.$el.find('.select-brand-dropdown').data('fields-to-be-disabled')).attr('disabled', 'disabled').removeClass('is-error');
    }
    _self.$(_self.$el.find('.mi-select')).selectric('refresh');
    if(_self.$el.find('input[name="associateViewFlag"]').val() === 'true'){
      if(_self.$(_self.$el.find('input[name="hotelName"]')).val() === '') {
        _self.$el.find('input[name="propertyCode"]').val('');
      }
    } else {
      _self.$el.find('input[name="propertyCode"]').val('');
    }
  }
});
